import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Spinner, Text, useToast } from '@chakra-ui/react';
import { useAuth } from '../providers/AuthProvider';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const toast = useToast();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (!code) {
        console.error('No code received from Discord');
        navigate('/login');
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/discord/callback?code=${code}`);
        const data = await response.json();

        if (response.ok) {
            localStorage.setItem('auth_token', data.token);
            setUser(data.user);
            navigate('/admin');
        } else {
            throw new Error(data.error || 'Authentication failed');
        }

        if (!response.ok) {
          throw new Error(data.message || data.error || 'Authentication failed');
        }

        localStorage.setItem('auth_token', data.token);
        setUser(data.user);
        navigate('/admin');
      } catch (error) {
        console.error('Auth error:', error);
        toast({
          title: 'Authentication Error', 
          description: error.message,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate, setUser, toast]);

  return (
    <Flex direction="column" align="center" justify="center" h="100vh">
      <Spinner size="xl" mb={4} />
      <Text>Authenticating with Discord...</Text>
    </Flex>
  );
}